import { FieldType, SearchField } from 'modules/domains';

export const getConditionFieldType = (condition: SearchField): FieldType | undefined =>
  'fieldType' in condition ? condition.fieldType : undefined;
